import { romanContextWords } from './lists';

export const toRoman = (num: number) => {
  const vals = [1000, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1];
  const syms = ['M', 'CM', 'D', 'CD', 'C', 'XC', 'L', 'XL', 'X', 'IX', 'V', 'IV', 'I'];
  return vals.reduce((result, val, i) => {
    while (num >= val) {
      result += syms[i];
      num -= val;
    }
    return result;
  }, '');
};

const ptnStrCtx: string = String.raw`(${romanContextWords.join('|')})\p{L}*(?!\p{L})`;
const ptnStrSep: string = String.raw`(?:\s*[,\-]\s*|\s+(?:og|eða|né|ásamt)\s+|\s+)`;
// Like ptnStrSep, but for a separator at the START of a string (no required leading whitespace).
// Used when a sequence's linking conjunction lands at the head of the incoming segment, e.g. "og VII. fingurs".
const ptnStrSepLead: string = String.raw`(?:(?:og|eða|né|ásamt)\s+|[,\-]\s*)`;
const ptnStrRomanNum: string = String.raw`(?=[IVXLCDM])M{0,3}(?:CM|CD|D?C{0,3})(?:XC|XL|L?X{0,3})(?:IX|IV|V?I{0,3})`;
const ptnStrArabNumFull: string = String.raw`(?<=^|\s)[0-9]+\.?(?:${ptnStrSep}[0-9]+\.?)*\s*`;
const ptnStrArabNumPartial: string = String.raw`(?<=^|\s)[0-9]+\.?(?:${ptnStrSep}[0-9]+\.?)*${ptnStrSep}$`;

// NOTE: We keep those here for optimization, so we don't need to construct the patterns for every single call to addSegment.
export const romanContentBoundaryRuleDefs = {
  first: {
    // Whole sequence or a single number.
    // Example: "...um að ræða 3. og 4. <>fingur en það eru..." -> "...um að ræða III. og IV. <>fingur en það eru..."
    // Example: "...um að ræða 3. <>fingur en það eru..." -> "...um að ræða III. <>fingur en það eru..."
    precedingPattern: new RegExp(String.raw`${ptnStrArabNumFull}$`),
    incomingMsgPattern: new RegExp(`^${ptnStrCtx}`, 'ui'),
  },
  second: {
    // Partial sequence.
    // Example: "...um að ræða 3. og <>IV. fingur en það eru..." -> "...um að ræða III. og <>IV. fingur en það eru..."
    precedingPattern: new RegExp(ptnStrArabNumPartial),
    incomingMsgPattern: new RegExp(
      String.raw`^${ptnStrSepLead}?${ptnStrRomanNum}\.?(?:${ptnStrSep}${ptnStrRomanNum}\.?)*\s+${ptnStrCtx}`,
      'ui',
    ),
  },
};

export const romanIncomingMsgBoundaryRuleDefs = {
  first: {
    // Beginning of a sequence or a single number.
    // Example: "...um að ræða fingur <>3 en það eru..." -> "...um að ræða fingur <>III en það eru..."
    // Example: "...um að ræða fingur <>3 og 4 en það eru..." -> "...um að ræða fingur <>III og IV en það eru..."
    precedingPattern: new RegExp(String.raw`${ptnStrCtx}\s*$`, 'ui'),
    incomingMsgPattern: new RegExp(String.raw`^${ptnStrArabNumFull}`),
  },
  second: {
    // Partial sequence.
    // Example: "...um að ræða fingur III og <>4 en það eru..." -> "...um að ræða fingur III og <>IV en það eru..."
    precedingPattern: new RegExp(
      String.raw`(?<=^|\s)${ptnStrCtx}\s${ptnStrRomanNum}\.?(?:${ptnStrSep}${ptnStrRomanNum}\.?)*${ptnStrSep}?$`,
      'ui',
    ),
    incomingMsgPattern: new RegExp(String.raw`^${ptnStrSepLead}?${ptnStrArabNumFull}`),
  },
};
